module.exports = new __parcel__URL__("invoicePayInfographic.85502539.png").toString();